import React, { useState, useEffect } from "react";
import { useIntl } from 'react-intl';
import { useSelector } from "react-redux";

// Components
import Select from 'Components/Select';
import { Form } from 'Components';
import Slider from 'Components/Slider';
import { Grid } from '@mui/material';
import { Typography } from '@mui/material';
import TriggerLandmark from "Modules/alerts/components/wizardAlert/common/components/TriggerLandmark";

export const OnEvent = (props) => {

    const { value, onChange, formRef, currentAlert, setCurrentAlert, triggers, triggersRaw } = props
    const { messages, locale } = useIntl()

    useEffect(() => {
        if (value.event == undefined)
            onChange({
                ...value,
                event: '',
                inputs: [],
                inputState: 'On',
                ignitionState: 'On',
                speedOver: 0
            })
    }, [value])

    const inputEventOptions = [
        { id: '1', name: messages['alertsNewAlert_Input1'] },
        { id: '2', name: messages['alertsNewAlert_Input2'] },
        { id: '3', name: messages['alertsNewAlert_Input3'] },
        { id: '4', name: messages['alertsNewAlert_Input4'] },
        { id: '5', name: messages['alertsNewAlert_Input5'] },
    ];

    const inputName = {
        1: messages['alertsNewAlert_Input1'],
        2: messages['alertsNewAlert_Input2'],
        3: messages['alertsNewAlert_Input3'],
        4: messages['alertsNewAlert_Input4'],
        5: messages['alertsNewAlert_Input5'],
    };

    const inputStateOptions = [
        { id: 'On', name: messages['alertsNewAlert_On'] },
        { id: 'Off', name: messages['alertsNewAlert_Off'] },
        { id: 'Both', name: messages['alertsNewAlert_Both'] },
    ];

    const inputDrivingOptions = [
        { id: 'Driving', name: messages['alertsNewAlert_Driving'] },
        { id: 'NotDriving', name: messages['alertsNewAlert_NotDriving'] },
        { id: 'Both', name: messages['alertsNewAlert_Both'] },
    ];

    const thereAreInputs = value.inputs?.length > 0;

    const [events, setEvents] = useState([])
    const { alertTypesSupported } = useSelector(state => state.alertsWizardRedux)
    const [showErrorTrigger, setShowErrorTrigger] = useState(false)

    useEffect(() => {
        if (alertTypesSupported && alertTypesSupported?.length > 0) {
            let supported = alertTypesSupported.filter((alert) => alert.parentId === 12);
            supported = supported?.map(alert => (
                { ...alert, name: messages['alertsNewAlert_' + alert.name?.replace(/\s/g, "")] }
            ))
            setEvents(supported);
        }
    }, [alertTypesSupported, locale])

    return (
        <Form ref={formRef}
              onSubmit={() => {
                  if (value.trigger) {
                      let isValid = triggersRaw?.length > 0

                      if (!isValid) {
                          setShowErrorTrigger(true)
                      } else setShowErrorTrigger(false)
                      return isValid
                  }
              }}
        >
            <div>
                <Select
                    required
                    value={events.find((option) => option.code === value.event)}
                    onChange={(value) => {
                        setCurrentAlert({...currentAlert, unitVersionIds: value?.unitVersionIds})
                        onChange({
                            ...value,
                            event: value.code,
                        })}
                    }
                    id="onEventSelect"
                    placeholder={messages['alertsNewAlert_SelectPlaceholder']}
                    options={events}
                    textField="name"
                    valueField="code"
                    label={messages['alertsNewAlert_Event']}
                    requiredMessage={messages['required_field']}
                />
                {
                    value.event === 'Input' && (
                        <Grid item>
                            <Select
                                id="OnEventAlertInputs"
                                label={messages['alertsNewAlert_InputLabel']}
                                value={value.inputs?.map((input) => ({ name: inputName[input], id: input }))}
                                onChange={(inputsResult) => {
                                    onChange({
                                        ...value,
                                        inputs: inputsResult?.map((input) => input.id) || [],
                                        inputState: thereAreInputs ? value.inputState : 'On',
                                        ignitionState: thereAreInputs ? value.ignitionState : 'On'
                                    })
                                }}
                                options={inputEventOptions}
                                textField="name"
                                valueField="id"
                                placeholder={messages['alertsNewAlert_selectPlaceholder']}
                                isClearable
                                selectedOptionsBelow
                                multiple
                                required
                                requiredMessage={messages['required_field']}
                            />
                            {
                                thereAreInputs && (
                                    <>
                                        <Select
                                            required
                                            requiredMessage={messages['required_field']}
                                            value={inputStateOptions.find((option) => option.id === value.ignitionState)}
                                            onChange={(newValue) => onChange({
                                                ...value,
                                                ignitionState: newValue.id,
                                            })}
                                            id="onEventIgnition"
                                            options={inputStateOptions}
                                            textField="name"
                                            valueField="id"
                                            label={messages['alertsNewAlert_State']}
                                        />
                                        <Select
                                            required
                                            requiredMessage={messages['required_field']}
                                            value={inputStateOptions.find((option) => option.id === value.inputState)}
                                            onChange={(newValue) => onChange({
                                                ...value,
                                                inputState: newValue.id,
                                            })}
                                            id="onEventState"
                                            options={inputStateOptions}
                                            textField="name"
                                            valueField="id"
                                            label={messages['alertsNewAlert_Ignition']}
                                        />
                                        <Select
                                            value={inputDrivingOptions.find((option) => option.id === value.drivingState) || inputDrivingOptions[1]}
                                            onChange={(newValue) => onChange({
                                                ...value,
                                                drivingState: newValue.id,
                                            })}
                                            id="onEventIgnition"
                                            options={inputDrivingOptions}
                                            textField="name"
                                            valueField="id"
                                            label={messages['alertsNewAlert_Driving']}
                                        />
                                    </>
                                )}
                            {
                                value.drivingState === 'Driving' && (
                                    <>
                                        <Typography variant="body2">
                                            <strong>{messages['alertsNewAlert_Over']}</strong>
                                        </Typography>
                                        <Slider
                                            min={1}
                                            max={35}
                                            sliderOneColor={false}
                                            showValue
                                            valueLabelDisplay={'off'}
                                            value={value.speedOver || 1}
                                            measure={messages['alertsNewAlert_SpeedUnitMph']}
                                            onChange={(event) => onChange({ ...value, speedOver: event })}
                                            sliderStep={5}
                                        />
                                    </>
                                )}
                        </Grid>
                    )}
                <Grid item style={{paddingTop:10}}>
                    <TriggerLandmark config={value} triggers={triggers} triggersRaw={triggersRaw} onChange={onChange} showErrorTrigger={showErrorTrigger}/>
                </Grid>
            </div>
        </Form>
    );
}
